/*
 * Rules filters in the URL: q (rule wording), at=YYYY-MM-DD (in force on), stage=<code>,
 * status=active|inactive. Pure parse/serialise; defaults are left out, ?change= is not ours.
 */
import { RULES_FILTERS_DEFAULT, STAGES } from './logic';

export const RULES_URL_KEYS = ['q', 'at', 'stage', 'status'];
const STATUSES = ['active', 'inactive'];
const Q_MAX = 100;

// A whole date from 1900 on: a date input passes partial years (0002, 0020, 0202) while one is typed.
const real_day = (v) => {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v);
  if (!m || +m[1] < 1900) return false;
  const d = new Date(Date.UTC(+m[1], +m[2] - 1, +m[3]));
  return d.getUTCFullYear() === +m[1] && d.getUTCMonth() === +m[2] - 1 && d.getUTCDate() === +m[3];
};

// The "In force on" value to apply: empty (today) or a whole date; anything else stays a draft.
export const applicable_day = (v) => v === '' || real_day(v);

export const parse_rules_filters = (search) => {
  const qs = new URLSearchParams(typeof search === 'string' ? search : '');
  const get = (k) => (qs.get(k) || '').trim();
  const stage = get('stage');
  return {
    filters: {
      ...RULES_FILTERS_DEFAULT,
      q: get('q').slice(0, Q_MAX),
      stage: STAGES.some(([code]) => code === stage) ? stage : '',
      status: STATUSES.indexOf(get('status')) !== -1 ? get('status') : ''
    },
    at: real_day(get('at')) ? get('at') : ''
  };
};

export const rules_query = (filters, at) => {
  const f = filters || {};
  return {
    q: (f.q || '').trim(),
    at: at || '',
    stage: f.stage || '',
    status: f.status || ''
  };
};
